import React, { useState } from 'react';
import './FilterPanel.css';
import { ActiveFilter, FILTER_FIELDS, STRING_OPERATORS, NUMBER_OPERATORS } from './types';

interface FilterPanelProps {
  isOpen: boolean;
  onAddFilter: (filter: ActiveFilter) => void;
}

export default function FilterPanel({ isOpen, onAddFilter }: FilterPanelProps) {
  const [selectedField, setSelectedField] = useState(FILTER_FIELDS[0].key);
  const [selectedOperator, setSelectedOperator] = useState<string>('=');
  const [value, setValue] = useState('');

  const fieldDef = FILTER_FIELDS.find(f => f.key === selectedField)!;
  const operators = fieldDef.fieldType === 'number' ? NUMBER_OPERATORS : STRING_OPERATORS;

  const handleFieldChange = (key: string) => {
    setSelectedField(key);
    const newDef = FILTER_FIELDS.find(f => f.key === key)!;
    const ops = newDef.fieldType === 'number' ? NUMBER_OPERATORS : STRING_OPERATORS;
    if (!(ops as readonly string[]).includes(selectedOperator)) {
      setSelectedOperator(ops[0]);
    }
    setValue('');
  };

  const handleAdd = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    onAddFilter({
      id: `${selectedField}_${selectedOperator}_${trimmed}_${Date.now()}`,
      field: selectedField,
      operator: selectedOperator,
      value: trimmed,
    });
    setValue('');
  };

  if (!isOpen) return null;

  return (
    <div className="tc-filter-panel">
      <select
        className="tc-filter-select"
        value={selectedField}
        onChange={e => handleFieldChange(e.target.value)}
      >
        {FILTER_FIELDS.map(f => (
          <option key={f.key} value={f.key}>{f.label}</option>
        ))}
      </select>

      <select
        className="tc-filter-select tc-filter-select--narrow"
        value={selectedOperator}
        onChange={e => setSelectedOperator(e.target.value)}
      >
        {operators.map(op => (
          <option key={op} value={op}>{op}</option>
        ))}
      </select>

      <input
        className="tc-filter-input"
        type={fieldDef.fieldType === 'number' ? 'number' : 'text'}
        placeholder="Value"
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter') handleAdd(); }}
      />

      <button className="tc-filter-add-btn" onClick={handleAdd} title="Add filter">
        ✓
      </button>
    </div>
  );
}
